<template>
    <b-card>
      <div slot="header">
        {{ event.title }}
      </div>
      <event-form :event="event"/>
    </b-card>
</template>

<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import EventForm from "../../components/events/EventForm";

    export default {
        name: "EventItem",
      components: {EventForm},
      data() {
          return {
            event: null,
            eventId: this.$route.params.eventId,
          }
        },
        created() {
          RepositoryFactory
            .get('event')
            .getEvent(this.eventId)
            .then(
              response => {
                this.event = response.data.data;
              }
            )
        }
    }
</script>

<style scoped>

</style>
